<template>
  <div class="">

    <div class="declare_outer"  :class="{'view':mode=='view'}">
      <div class="declare_cont">
        <div class="head">
          <div class="tit">
            项目申报表
          </div>
        </div>

        <div class="">
          <el-form :model="sbInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="form_cont_module">
              <div class="m_head">
                项目申报
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg" width="300px">项目名称 <span style="color: red;font-weight: bold">*</span></td>
                    <td>
                      <el-form-item  prop="xmmc">
                      <el-input v-model="sbInfo.xmmc" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">企业名称 <span style="color: red;font-weight: bold">*</span></td>
                    <td>
                      <el-form-item  prop="cname">
                      <el-input v-model="sbInfo.cname" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">项目分类 <span style="color: red;font-weight: bold">*</span></td>
                    <td>
                      <el-form-item  prop="xm_cate">
                      <el-select v-model="sbInfo.xm_cate" placeholder="请选择" @change="indChange" style="width:100%" :disabled="mode==='view'">
                        <el-option
                          v-for="item in options2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">申报大类</td>
                    <td>
                      <el-select v-model="sbInfo.sb_cate" placeholder="请选择" @change="indChange" style="width:100%" :disabled="mode==='view'">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">投资资金（万元） <span style="color: red;font-weight: bold">*</span></td>
                    <td>
                      <el-form-item  prop="tzje">
                      <el-input v-model="sbInfo.tzje" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                     </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">可享受资助资金（万元） <span style="color: red;font-weight: bold">*</span></td>
                    <td>
                      <el-form-item  prop="zzje">
                      <el-input v-model="sbInfo.zzje" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">已资助资金（市、区、开发区）（万元） <span style="color: red;font-weight: bold">*</span></td>
                    <td>
                      <el-form-item  prop="yzzj">
                      <el-input v-model="sbInfo.yzzj" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">申报年度</td>
                    <td>
                      <el-input v-model="sbInfo.year" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="form_cont_module">
              <div class="m_head">
                申报附件
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg" colspan="2">序号</td>
                    <td class="td_bg" colspan="2">文件名称</td>
                    <td class="td_bg text_center">上传时间</td>
                    <td class="td_bg text_center">操作</td>
                  </tr>
                  <tr v-for="(item,index) in filesList">
                    <td colspan="2">{{index+1 }}</td>
                    <td colspan="2">{{ item.name }}</td>
                    <td class="text_center">{{ item.create_time }}</td>
                    <td>
                      <div class="btn_outer text_center">
                        <el-button type="success" @click="downloadFile(item.filepath,item.name)" plain><i class="cloudicon ci_download"></i>
                          下载
                        </el-button>
                        <el-button  v-if="mode!=='view'" type="danger" @click="del(index)" plain><i class="cloudicon ci_delect" ></i>
                          删除
                        </el-button>
                      </div>
                    </td>
                  </tr>
                  <tr  v-if="mode!=='view'">
                    <td colspan="6">
                      <div class="btn_outer text_right">
                        <el-upload
                          class="upload-demo"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove"
                          :before-remove="beforeRemove"
                          :on-exceed="handleExceed"
                          :http-request="htrupl"
                        >
                          <el-button size="small" type="primary">点击上传</el-button>
                          <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                        </el-upload>
                        <!--<el-button type="primary" plain> <i class="cloudicon ci_upload"></i> <div>上传</div></el-button>-->
                      </div>

                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="save_btn_outer" v-if="mode!=='view'">
              <el-button type="primary" plain @click="onAddProject(1,'ruleForm')">
                <div>提交</div>
              </el-button>
              <el-button type="primary" plain @click="onAddProject(0,'ruleForm')">
                <div>暂存</div>
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {

    let redisKey= this.$route.query.rediskey;
    if(redisKey!==undefined && redisKey!=null){
      window.localStorage.setItem("gyzhqy_token",redisKey);
      this.rediskey=redisKey;
    }

    let id =this.id || this.$route.query.id;
    let mode=this.modeD || this.$route.query.mode;
    if(mode!==undefined && mode!==null){
      this.mode=mode;
    }

    if(id!==undefined && id!==null){ // 这里是修改或者查看
      this.getDetail(id);
    }else{
      this.sbInfo.policy_id = this.$route.query.policy_id;
      if (JSON.parse(window.localStorage.getItem("gyzhqy_corp_info")) != null) {
        let corpInfo = JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"));
        this.sbInfo.cname=corpInfo.cname;
      }

    }
  },
  name: 'declare2',
  props: ['id','modeD'],
  data() {
    return {
      rediskey:null,
      mode:'',
      filesList: [
      ],
      sbInfo: {
        policy_id: null,
        cname: null,
        xmmc: null,
        xm_cate: null,
        sb_cate: null,
        tzje: null,
        zzje: null,
        yzzj: null,
        year: null,
      },
      options2:[
        {
          value: 1,
          label: '立项'
        },
        {
          value: 2,
          label: '申请'
        },  {
          value: 3,
          label: '验收'
        }
      ],
      options: [{
        value: 1,
        label: '科技创新类'
      }, {
        value: 2,
        label: '结构调整类'
      }, {
        value: 3,
        label: '循环经济类'
      }, {
        value: 4,
        label: '品牌建设类'
      }, {
        value: 5,
        label: '融资上市类'
      },
        {
          value: 6,
          label: '提升管理类'
        }, {
          value: 7,
          label: '人才引进类'
        }, {
          value: 8,
          label: '盘活资源类'
        }, {
          value: 9,
          label: '重点产业类'
        }, {
          value: 10,
          label: '平台经济类'
        }, {
          value: 11,
          label: '其他'
        }
      ],

      ruleForm: {
        cname: '',
        xmmc:'',
        xm_cate:'',
        zzje:'',
        yzzj:'',
        tzje:''
      },

      rules: {
        cname: [
          {type: 'string', required: true, message: '请输入企业名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        xmmc: [
          {type: 'string', required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        xm_cate: [
          {type: 'number', required: true, message: '请选择项目分类', trigger: 'change' },
        ],
        zzje: [
          {type: 'string', required: true, message: '请输入可享受资助资金', trigger: 'blur' },
        ],
        yzzj: [
          {type: 'string', required: true, message: '请输入已资助资金', trigger: 'blur' },
        ]
        , tzje: [
          {type: 'string', required: true, message: '请输入投资资金', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    indChange(e) {
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    htrupl(param) {
      let fileName = param.file.name.lastIndexOf(".");//取到文件名开始到最后一个点的长度
      let fileNameLength = param.file.name.length;//取到文件名长度
      let fileFormat = param.file.name.substring(fileName + 1, fileNameLength);//截
      const formData = new FormData()
      formData.append('file', param.file);
      this.$ajax.post(this.bUrl + 'api/portal/user/webuploader?_ajax=1&filetype=file', formData).then(function (res) {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg);
          this.filesList.push(res.data.data);
        } else {
          this.$message.error(res.data.msg)
        }
      }.bind(this)).catch(function (error) {
        console.log(error);
      });
    },

    async onAddProject(status,formName) {
     this.$refs[formName].validate((valid) => {
        if (valid) {
         this.addProject(status);
        } else {

          setTimeout(()=>{
            var isError = document.getElementsByClassName("is-error");
            console.log(isError)
            var htmlInputElement = isError[0].querySelector('input');
            if(htmlInputElement) htmlInputElement.focus();

            var htmlAreaElement = isError[0].querySelector('textarea');
            if(htmlAreaElement) htmlAreaElement.focus();
          },100);
         // alert('error submit!!');
          return false;
        }
      });
    },

    async addProject(status){
       let data = this.sbInfo;
       data.status=status;
       data.attachments=this.filesList.map(item=>item.id).join(',')
       let res01 = await this.$ajax.post(this.bUrl + 'api/portal/zxzj/save',data);
       if(res01.data.code===200){
         this.$message.success(res01.data.msg);
         this.$emit('emitClose')
         if(this.$route.query.fname=='notidetail'){this.$router.push({name:'userproject'})}
       }else{
         this.$message.error(res01.data.msg);
         this.$emit('emitClose')
       }
    },

    downloadFile(url,name) {
//    window.location.href = url;
      this.$down.download (url, name)
    },
    del(index){
      this.filesList.splice(index,1)
    },
    async getDetail(id) {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/zxzj/detail?id=' + id);
      for (let key in this.sbInfo) {
        this.sbInfo[key] = res.data.data[key];
      }
      this.filesList = res.data.data.attachments;
    }
  }
}
</script>

<style scoped>

.declare_outer {
  background: #fff;
}

.declare_cont {
  width: 1180px;
  margin: 0 auto;
  padding:36px 66px;
  box-sizing: border-box;
  color: #666666;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  margin-top: 20px;
}

.declare_cont .head {
  text-align: center;
  /*margin-bottom: 20px;*/
}

.declare_cont .head .tit {
  font-size: 24px;
  color: #5F5F5F;
}

.form_cont_module {
  margin-bottom: 26px;
}

.form_cont_module .m_head {
  line-height: 50px;
  font-size: 18px;
}

.save_btn_outer {
  text-align: center;
  margin-top: 44px;
}


</style>



// WEBPACK FOOTER //
// src/components/NotiDeclare/declare2.vue